module.exports = __webpack_public_path__ + "img/Oryza_brachyantha.f1ad8d8f.jpg";